export const environment = {
  production: false,
  BASE_URL: 'http://64.225.52.122:8080/api',
  ETHEREUM_PROVIDER: 'https://holesky.infura.io/v3/3df86088496b4ef2ba618eb4764d0b7a',
  BINANCE_PROVIDER: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  V1_CONTRACT_ADDRESS: '0x32bF175bda7AFAf71Cf370f312E2fa178E9C7Fbe',
  MIGRATOR_ADDRESS: '0x5e20875aAF4fb740aF2f508b1834323740DDf23D',
  V2_CONTRACT_ADDRESS: '0xfc43a7F344970D55e168A7a86950D58a31ff7F60',
  projectId: 'ce7c7bb0dcadf584586f578ba078becb',
  SUPPORTED_NETWORK:17000,
  WEB_SITE_URL:'https://www.blockchainx.tech',
  SUPPORTED_CHAINS: ['17000'],
};